import * as ajax from './fetch'

(function() {
	'use strict'

    let search_timeout

    document.addEventListener( 'DOMContentLoaded', () => {
        add_events()
    })

	let add_events = () => {
            document.querySelectorAll( '.search-input input' ).forEach( ( elem, index ) => {
                /* Add listener */
                elem.addEventListener( 'keyup', ( ev ) => {
                    clearTimeout( search_timeout )
                    if ( ev.target.value != '' ) {
                        ev.target.closest( '.search-input' ).classList.add( 'has-value' )
                        search_timeout = setTimeout( apply_search, 250, ev.target )
                    } else {
                        ev.target.closest( '.search-input' ).classList.remove( 'has-value' )
                        reset_search( ev.target.closest( '.search-input' ) )
                    }
                })
            })
            
            document.querySelectorAll( '.date-input input' ).forEach( ( elem, index ) => {
                /* Add listener */
                elem.addEventListener( 'change', ( ev ) => {
                    if ( ev.target.classList.contains( 'is-ajax' ) ) {
                        load_events( ev.target )
                    }
                })
            })
            
            document.querySelectorAll( '.clear-input' ).forEach( ( elem, index ) => {
                /* Add listener */
                elem.addEventListener( 'click', ( ev ) => {
                    ev.preventDefault()
                    ev.target.closest( '.search-input' ).querySelector( 'input' ).value = ''
                    ev.target.closest( '.search-input' ).classList.remove( 'has-value' )
                    apply_search( ev.target.closest( '.search-input' ).querySelector( 'input' ) )
                })
            })

            document.querySelectorAll( '.filter span' ).forEach( ( elem, index ) => {
                /* Add listener */
                elem.addEventListener( 'click', ( ev ) => {
                    if ( ev.target.tagName.toLowerCase() == 'span' ) {
                        ev.preventDefault()
                        if ( ev.target.classList.contains( 'is-active' ) ) {
                            ev.target.classList.remove( 'is-active' )
                        } else {
                            document.querySelectorAll( '.filter span' ).forEach( (filter_elem ) => {
                                filter_elem.classList.remove( 'is-active' )
                            })
                            ev.target.classList.add( 'is-active' )
                            apply_filter( elem )
                        }
                    }
                })
            })
            
            document.querySelectorAll( '.location-input select' ).forEach( ( elem, index ) => {
                /* Add listener */
                elem.addEventListener( 'change', ( ev ) => {
                    apply_filter( elem )
                })
            })
        },
        apply_filter = ( filter ) => {
            let filter_value,
                filter_class = 'is-hidden-filter'
                
            if ( filter.tagName.toLowerCase() == 'select' ) {
                filter_value = filter.value
                filter_class = 'is-hidden-filter-location'
            } else {
                filter_value = filter.getAttribute( 'data-filter' )
            }
            
            if ( filter_value ) {
                filter.closest( '.module' ).querySelectorAll( '.filterable-list li:not([data-filters*="' + filter_value + '"])' )?.forEach( ( hit ) => {
                    hit.classList.add( filter_class )
                })
                filter.closest( '.module' ).querySelectorAll( '.filterable-list li[data-filters*="' + filter_value + '"]' )?.forEach( ( hit ) => {
                    hit.classList.remove( filter_class )
                })

                if ( filter.closest( '.module' ).querySelectorAll( '.filterable-list li:not(.is-hidden-search):not(.is-hidden-filter):not(.is-hidden-filter-location)' ).length <= 0 ) {
                    filter.closest( '.module' ).querySelector( '.no-results' ).classList.add( 'is-active' )
                } else {
                    filter.closest( '.module' ).querySelector( '.no-results' ).classList.remove( 'is-active' )
                }
            } else {
                reset_filter( filter, filter_class )
            }
        },
        reset_filter = ( filter, reset_class, reset_all = false ) => {
            filter.closest( '.module' ).querySelectorAll( '.filterable-list li' )?.forEach( ( elem ) => {
                elem.classList.remove( reset_class )
            })

            if ( reset_all ) {
                filter.closest( '.module' ).querySelectorAll( '[data-is-filter]' )?.forEach( ( elem ) => {
                    elem.value = ''
                })
                filter.closest( '.module' ).querySelectorAll( '.filter span' )?.forEach( ( elem ) => {
                    elem.classList.remove( 'is-active' )
                })
                filter.closest( '.module' ).querySelector( '.filter span:not(data-filter)' )?.classList.add( 'is-active' ) 
                filter.closest( '.module' ).querySelector( '.no-results' ).classList.remove( 'is-active')
            }
        },
        apply_search = ( search_input ) => {
            if ( search_input.value != '' ) {
                let search_field = 'data-search-' + search_input.getAttribute( 'name' )

                search_input.closest( '.module' ).querySelectorAll( '.filterable-list li:not([' + search_field + '*="' + search_input.value.toLowerCase() + '"])' )?.forEach( ( hit ) => {
                    hit.classList.add( 'is-hidden-search' )
                })
                search_input.closest( '.module' ).querySelectorAll( '.filterable-list li[' + search_field + '*="' + search_input.value.toLowerCase() + '"]' )?.forEach( ( hit ) => {
                    hit.classList.remove( 'is-hidden-search' )
                })

                if ( search_input.closest( '.module' ).querySelectorAll( '.filterable-list li:not(.is-hidden-search):not(.is-hidden-filter)' ).length <= 0 ) {
                    search_input.closest( '.module' ).querySelector( '.no-results' ).classList.add( 'is-active' )
                } else {
                    search_input.closest( '.module' ).querySelector( '.no-results' ).classList.remove( 'is-active' )
                }
            } else {
                reset_search( search_input )
            }
        },
        reset_search = ( search_input ) => {
            search_input.closest( '.module' ).querySelectorAll( '.filterable-list li.is-hidden-search' )?.forEach( ( elem ) => {
                elem.classList.remove( 'is-hidden-search' )
            })
            search_input.closest( '.module' ).querySelector( '.search-input input' ).value = ''
            search_input.closest( '.module' ).querySelector( '.search-input' ).classList.remove( 'has-value' )
            search_input.closest( '.module' ).querySelector( '.no-results' ).classList.remove( 'is-active')
        },
        load_events = ( date_input ) => {
            /* Add classes */
            date_input.closest( '.module' ).classList.add( 'is-loading' )

            /* Setup */
            let params = {
                    action: 'meinefreikarte_load_events',
                    _ajax_nonce: meinefreikarte.security,
                    date: date_input.value
                },
                options = {
                    body: params
                }

            ajax.post(
                meinefreikarte.url,
                options
            ).then((content) => {
                /* Check for cookies */
                if ( content != '' ) {
                    /* Set new items */
                    date_input.closest( '.module' ).querySelector( '.filterable-list' ).innerHTML = content
                }

                /* Remove classes */
                reset_search( date_input )
                reset_filter( date_input, 'is-hidden-filter-location,is-hidden-filter', true )
                date_input.closest( '.module' ).classList.remove( 'is-loading' )
            })
        }
})( )